/**
 * Client-side role helpers, for deciding what to SHOW only.
 *
 * The role is read from the JWT issued by the backend. Real authorization happens on the
 * server: every protected endpoint checks the token ([Authorize] / [Authorize(Roles = "Admin")]).
 */

import { AUTH_TOKEN } from '../configs/configs';
import { decodeToken } from './session';

const readToken = () => {
  try {
    return localStorage.getItem(AUTH_TOKEN);
  } catch {
    return null;
  }
};

/** The signed-in user's role from the JWT ("admin", "user"), lower-cased, or null. Not verified. */
export const decodeJWTRole = () => {
  const token = readToken();
  if (!token) return null;
  const payload = decodeToken(token);
  if (!payload) return null;
  const role =
    payload.role ||
    payload.roles ||
    payload.userRole ||
    payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  return role ? String(role).toLowerCase() : null;
};

/** True if the JWT carries one of the roles (UI only). */
export const hasRole = allowedRoles => {
  const userRole = decodeJWTRole();
  if (!userRole) return false;
  const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  return roles.some(role => role.toLowerCase() === userRole);
};

export const isAdmin = () => hasRole('admin');
